module.exports = __webpack_public_path__ + "img/Cloud-Rain.316ec331.svg";